import glassWallPartTypes from 'components/configurator/types/glassWallPartTypes';
import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IWall from 'components/interfaces/IWall';

import handleGlassWallProperties from '../handleGlassWallProperties';

const doorUpdater =
  (wall: IWall) =>
  (doorId: number, updatedDoor: IGlassWallDoor): void => {
    handleGlassWallProperties({
      target: {
        name: 'parts',
        value: wall.parts.map((part: any) =>
          part.type === glassWallPartTypes.door && part.id === doorId
            ? updatedDoor
            : part
        ),
      },
    });
  };

export default doorUpdater;
